import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-50 dark:bg-black px-6 py-4 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" }
const _hoisted_3 = { class: "flex items-center text-sm text-gray-700 dark:text-gray-300 order-2 sm:order-1" }
const _hoisted_4 = { class: "flex items-center justify-center sm:justify-end space-x-2 order-1 sm:order-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "flex items-center space-x-1" }
const _hoisted_7 = ["onClick", "onMouseover", "onMouseout"]
const _hoisted_8 = {
  key: 1,
  class: "px-2 py-1 text-sm text-gray-500 dark:text-gray-400"
}
const _hoisted_9 = ["disabled"]

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerPagination',
  props: {
    currentPage: {},
    lastPage: {},
    perPage: {},
    total: {}
  },
  emits: ["prev", "next", "goto"],
  setup(__props: any) {

const props = __props;



const from = computed(() => {
  return (props.currentPage - 1) * props.perPage + 1;
});

const to = computed(() => {
  return Math.min(props.currentPage * props.perPage, props.total);
});

// Visible pages with ellipsis support (like reference project)
const visiblePagesWithEllipsis = computed(() => {
  const pages: (number | string)[] = [];
  const maxVisiblePages = 5;
  const halfVisible = Math.floor(maxVisiblePages / 2);

  let startPage = Math.max(1, props.currentPage - halfVisible);
  let endPage = Math.min(props.lastPage, startPage + maxVisiblePages - 1);

  // Adjust startPage if needed
  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  // Add first page and ellipsis if needed
  if (startPage > 1) {
    pages.push(1);
    if (startPage > 2) {
      pages.push('...');
    }
  }

  // Add visible pages
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  // Add ellipsis and last page if needed
  if (endPage < props.lastPage) {
    if (endPage < props.lastPage - 1) {
      pages.push('...');
    }
    pages.push(props.lastPage);
  }

  return pages;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "Showing " + _toDisplayString(from.value) + " to " + _toDisplayString(to.value) + " of " + _toDisplayString(_ctx.total) + " results", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prev'))),
          disabled: _ctx.currentPage === 1,
          class: "px-3 py-1 text-sm bg-white dark:bg-black border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
        }, " Previous ", 8, _hoisted_5),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePagesWithEllipsis.value, (page) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
              (page !== '...')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.$emit('goto', page)),
                    class: _normalizeClass([
                'px-3 py-1 text-sm rounded-md transition-colors duration-150',
                page !== _ctx.currentPage
                  ? 'bg-white dark:bg-black border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600'
                  : 'text-white'
              ]),
                    style: _normalizeStyle(page === _ctx.currentPage ? {
                backgroundColor: 'var(--brand-primary)',
                borderColor: 'var(--brand-primary)'
              } : {}),
                    onMouseover: (e) => {
                if (page === _ctx.currentPage) {
                  (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--brand-hover)';
                  (e.currentTarget as HTMLElement).style.borderColor = 'var(--brand-hover)';
                }
              },
                    onMouseout: (e) => {
                if (page === _ctx.currentPage) {
                  (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--brand-primary)';
                  (e.currentTarget as HTMLElement).style.borderColor = 'var(--brand-primary)';
                }
              }
                  }, _toDisplayString(page), 47, _hoisted_7))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, " ... "))
            ], 64))
          }), 128))
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next'))),
          disabled: _ctx.currentPage === _ctx.lastPage,
          class: "px-3 py-1 text-sm bg-white dark:bg-black border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
        }, " Next ", 8, _hoisted_9)
      ])
    ])
  ]))
}
}

})